/* global axios */

import ApiClient from './ApiClient';

class AgentLogsAPI extends ApiClient {
  constructor() {
    super('agent_logs', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new AgentLogsAPI();
